<template>
  <div id="modal-body">
    <b-row class="report-form">
      <b-col sm="12">
        <p class="sub">pricewagon에 없는 새로운 상품을 등록해주세요.</p>
        <b-form-group label="제품 종류">
          <b-form-select 
            size="sm" 
            text-field="name"
            value-field="_id"
            v-model="category_id"
            :options="category_list"
          ></b-form-select>
        </b-form-group>
        <b-input-group>
          <b-form-textarea class="content-textarea" v-model="content" @keyup.enter="submit" placeholder="쇼핑몰 링크"></b-form-textarea>
        </b-input-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BIconCheck
} from 'bootstrap-vue'
import { api_post } from '../../util'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'RequestModal',
  components: {
    BRow, BCol, BIconCheck
  },
  props: {
  },
  data () {
    return {
      content: '',
      category_id: null
    }
  },
  mounted() {
    this.category_id = this._category_id
  },
  computed: {
    ...mapState({
      category_list: state => state.category.list,
      _category_id: state => state.filter.category_id
    })
  },
  methods: {
    submit () {
      return api_post(`report/${this.category_id}`, {
        content: this.content
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
p.sub {
  color: grey;
  font-size: 0.8rem;
}
.content-wrapper {
  position: relative;
  padding: 30px;
}

.content-textarea {
  height: 200px;
}
.input-group {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/RequestModal.vue